import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import useScrollHandlerGroup from '@hooks/useScrollHandlerGroup';
import H5 from '@base/H5/H5';
import { Context as MobileContext } from '../../../Context/IsMobileContext';
import { allSections, headerSections } from '../sections';
import { Fonts, mobile } from '../../../../styleConstants';

const SectionName = styled(H5)`
  color: ${({ $isActive }) => ($isActive ? '#1f2432' : '#7b8ab5')};
  cursor: pointer;
  font-weight: ${({ $isActive }) =>
    $isActive ? Fonts.SEMIBOLD : Fonts.REGULAR};
  text-align: center;
  @media only screen and (min-width: ${mobile.maxWidth}) {
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

const Sections = ({ headerRefs }) => {
  const isMobileDevice = useContext(MobileContext);
  const refs = allSections.map((section) => ({
    ref: headerRefs[section.id],
    shrinkPos: isMobileDevice ? 40 + 30 : 72 + 70,
    id: section.id
  }));
  const { activeStatuses, scrollToElement } = useScrollHandlerGroup(refs);
  const onSectionClick = (ref, id) => () => {
    const element = ref.current?.parentElement;
    if (element) {
      scrollToElement(element, id, {
        offsetTop: isMobileDevice
          ? 40
          : ((window.innerWidth - ref.current.getBoundingClientRect().width) /
              2) *
            (window.innerHeight / window.innerWidth)
      });
    }
  };
  return (
    <>
      {headerSections.map((section, index) => (
        <SectionName
          key={section.id}
          onClick={onSectionClick(headerRefs[section.id], section.id)}
          $isActive={activeStatuses[index]}
        >
          {section.name}
        </SectionName>
      ))}
    </>
  );
};

Sections.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default Sections;
